import { useT } from "../i18n";

/**
 * 로딩·진행 표시 — 진행 바 + 단계 목록(부품 ✓ · 내 기계 ✓ · 친구 작품 …). SCR v0.6 FS-01-01.
 * 진행 바는 role=progressbar, 단계는 목록으로 읽힌다. 애니메이션은 reduced-motion 에서 끈다(CSS).
 */
export type StepState = "done" | "active" | "waiting";

export interface Step {
  id: string;
  label: string;
  state: StepState;
}

export function LoadingSteps({ steps, label }: { steps: readonly Step[]; label: string }) {
  const t = useT();
  const done = steps.filter((s) => s.state === "done").length;
  const pct = steps.length ? Math.round((done / steps.length) * 100) : 0;
  return (
    <div className="pf-loading">
      <div
        className="pf-progress"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={steps.length}
        aria-valuenow={done}
        aria-valuetext={steps
          .map((s) => {
            const k =
              s.state === "done"
                ? "common.stepDone"
                : s.state === "active"
                  ? "common.stepActive"
                  : "common.stepWaiting";
            return t(k, { label: s.label });
          })
          .join(", ")}
      >
        <i className="pf-progress__fill" style={{ width: `${pct}%` }} />
      </div>
      <ol className="pf-steps">
        {steps.map((s) => (
          <li key={s.id} className={`pf-step pf-step--${s.state}`} data-state={s.state}>
            {s.label}
            <span className="pf-step__mark" aria-hidden="true">
              {s.state === "done" ? " ✓" : s.state === "active" ? " …" : ""}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
